'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _Toolbox = require('./Toolbox');

var _Toolbox2 = _interopRequireDefault(_Toolbox);

var _DatePicker = require('./DatePicker.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DatePicker dialog input.
 * Currently implements material designs
 * [datepicker](https://github.com/react-toolbox/react-toolbox/tree/dev/components/date_picker#date-picker) from react-toolbox.
 * The value for the datepicker input will need to be stored externally as it
 * does not act upon the input itself.
 */
var DatePicker = function DatePicker(_ref) {
  var className = _ref.className,
      active = _ref.active,
      inputClassName = _ref.inputClassName,
      readonly = _ref.readonly,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['className', 'active', 'inputClassName', 'readonly']);
  return _react2.default.createElement(_Toolbox2.default, (0, _extends3.default)({ className: className }, rest));
};

exports.DatePicker = DatePicker;
DatePicker.propTypes = {
  /**
   * className required by glamorous
   * @ignore
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Automatically selects a date upon clicking on a day.
   */
  autoOk: _propTypes2.default.bool,
  /**
   * Label for cancel button
   */
  cancelLabel: _propTypes2.default.string,
  /**
  * Helper description for tooltip
  */
  description: _propTypes2.default.string,
  /**
   * Disable datepicker
   */
  disabled: _propTypes2.default.bool,
  /**
   * Array of date objects to be disabled in the calendar.
   */
  disabledDates: _propTypes2.default.array,
  /**
   * Array of date objects for enabled dates in calendar.
   * All other dates will be disabled.
   */
  enabledDates: _propTypes2.default.array,
  /**
   * Error message for input.
   * Alters input style and displays error message if set.
   */
  error: _propTypes2.default.string,
  /**
   * Function to format the date displayed in the input.
   * Function paramter will be date object and should return a string.
   * Defaults to using date.format
   */
  inputFormat: _propTypes2.default.func,
  /**
   * Field label text to display above input
   */
  label: _propTypes2.default.string,
  /**
   * Set the locale for the datePicker
   * @type {[type]}
   */
  locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  /**
   * Date object with maximum selectable date.
   */
  maxDate: _propTypes2.default.instanceOf(Date),
  /**
   * Date object with minimum selectable date.
   */
  minDate: _propTypes2.default.instanceOf(Date),
  /**
   * Field name in form
   */
  name: _propTypes2.default.string,
  /**
   * Label for OK button.
   */
  okLabel: _propTypes2.default.string,
  /**
   * Function to call on input blur
   */
  onBlur: _propTypes2.default.func,
  /**
   * Function to call on input change
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback called when the ESC key is pressed with the overlay active
   */
  onEscKeyDown: _propTypes2.default.func,
  /**
   * Function to call on input focus
   */
  onFocus: _propTypes2.default.func,
  /**
   * Placeholder text for input
   */
  placeholder: _propTypes2.default.string,
  /**
   * Whether week starts on Sunday or Monday.
   */
  sundayFirstDayOfWeek: _propTypes2.default.bool,
  /**
   * Props to pass on to the Input Component Wrapper.
   */
  wrapperProps: _propTypes2.default.object,
  /**
   * Input value
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string])
};
DatePicker.defaultProps = {
  autoOk: false,
  cancelLabel: 'CANCEL',
  locale: 'en',
  okLabel: 'OK',
  sundayFirstDayOfWeek: true
};

exports.default = (0, _glamorous2.default)(DatePicker)(_DatePicker.defaultStyle, _DatePicker.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/DatePicker/DatePicker.js
// module id = 518
// module chunks = 0